/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsMegaMenu = {
  init: function($section) {
    // Add settings from schema to current object
    const sectionData = window.PXUTheme.getSectionData($section);
    if (!sectionData) {
      console.warn('jsMegaMenu: No section data found');
      return;
    }
    
    window.PXUTheme.jsMegaMenu = $.extend(this, sectionData);

    // Selectors
    const parentLink = this.parent_link;
    const sectionId = this.section_id;
    
    // Add safety checks
    if (!parentLink || !sectionId) {
      console.warn('jsMegaMenu: Missing required data (parentLink or sectionId)', { parentLink, sectionId });
      return;
    }
    
    const $megaMenu = $section.find('.mega-menu__' + sectionId);
    if (!$megaMenu.length) {
      console.warn('jsMegaMenu: Mega menu element not found for section', sectionId);
      return;
    }
    
    const $parentElement = $('.header__menu [data-navlink-handle="' + parentLink + '"], .sticky-header__menu [data-navlink-handle="' + parentLink + '"]');
    const $parentElementLink = $parentElement.find('.header__link');
    // Remove old mega menus
    $parentElement.find('.mega-menu__section').remove();

    // Mobile Integration - Updated for accessible mobile menu structure
    this.setupMobileIntegration(parentLink, sectionId, $megaMenu);


    // Desktop
    if ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level')) {
      // Hide default dropdown
      $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden');

      // Add arrow to parent link to indicate dropdown
      $parentElementLink.removeClass('is-arrowless');

      $megaMenu.clone().appendTo('.vertical-header__first-level[data-navlink-handle="' + parentLink + '"], .header__item[data-navlink-handle="' + parentLink + '"]');

      // Add/remove classes for proper styling and append mega menu instance
      $parentElement.addClass('has-mega-menu')

      // Accessibility & keyboard support: use the newly inserted menu element
      const $clonedMenuEl = $parentElement.find('.mega-menu').last();
      this.setupAccessibility($parentElementLink, $clonedMenuEl, sectionId, $parentElement);
    }

    // Determine if header is set to hover to open or click to open
    if ($('.dropdown-click--false').length > 0) {
      $('.navbar-item, .header__brand, .header__search').on('mouseover', function(){

        //Close any mega menus on hover
        $('.mega-menu__section').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
        }
      })

      $('.mega-menu__section, .navbar').on('mouseleave', function(){

        //Hide mega menu upon leaving mega menu, logo or navbar
        $('.mega-menu__section').removeClass('is-active');
      })
    } else {
      $('.navbar-item, .header__brand, .header__search').on('click touchstart', function(){

        //Close any mega menus on click
        $('.mega-menu__section').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
        }
      })
    }
  },
  showThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
  },
  hideThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
  },
  displayMenu: function(id) {
    $('.mega-menu').removeClass('mega-menu--show');
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
  },
  hideMenu: function(id) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
  },
  unload: function($section) {
    let parentLink = $section.find('.mega-menu').data('parent-link');
    let navLink = $('[data-navlink-handle="' + parentLink + '"]')
    navLink.off();
    navLink.find('.mega-menu__section').remove();
    $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
  },

  /* -------------------------------------------------------------
   * Accessibility helpers
   * ----------------------------------------------------------- */
  setupAccessibility: function($triggerLink, $menuEl, sectionId, $parentItem) {
    const menuId = 'mega-menu-' + sectionId;

    // Assign id to the menu element for aria-controls reference
    if (!$menuEl.attr('id')) {
      $menuEl.attr('id', menuId);
    }

    // Apply required ARIA attributes to trigger link
    $triggerLink
      .attr('aria-haspopup', 'menu')
      .attr('aria-controls', menuId)
      .attr('aria-expanded', 'false');

    // Hint text for screen reader users – inserted once per menu
    const hintId = 'mega-menu-hint-' + sectionId;
    if (!document.getElementById(hintId)) {
      $('<span>', {
        id: hintId,
        class: 'sr-only',
        text: 'Enter again to visit page'
      }).insertAfter($triggerLink);
    }
    $triggerLink.attr('aria-describedby', hintId);

    // Live region for dynamic announcements – singleton across document
    if (!document.getElementById('mega-menu-live-region')) {
      $('<div>', {
        id: 'mega-menu-live-region',
        'aria-live': 'polite',
        class: 'sr-only'
      }).appendTo('body');
    }

    /* State machine -------------------------------------------------- */
    let state = 'closed'; // closed | justOpened | browsing

    const announce = (msg) => {
      $('#mega-menu-live-region').text(msg);
    };

    const openMenu = () => {
      window.PXUTheme.jsMegaMenu.displayMenu(sectionId);
      $triggerLink.attr('aria-expanded', 'true');
      $parentItem.addClass('is-opened');
      state = 'justOpened';
      announce('Menu opened. Press Tab to browse or Enter to visit ' + $triggerLink.text() + ' page');
    };

    const closeMenu = () => {
      window.PXUTheme.jsMegaMenu.hideMenu(sectionId);
      $triggerLink.attr('aria-expanded', 'false');
      $parentItem.removeClass('is-opened');
      state = 'closed';
      announce('Menu closed');
    };

    /* Keyboard interactions ----------------------------------------- */
    $triggerLink.on('keydown', function(e) {
      const key = e.key;
      if (key === 'Enter') {
        if (state === 'closed') {
          e.preventDefault();
          openMenu();
        } else if (state === 'justOpened') {
          // Allow default navigation – do not preventDefault()
        }
      } else if (key === 'Escape') {
        if (state !== 'closed') {
          e.preventDefault();
          closeMenu();
          $triggerLink.focus();
        }
      }
    });

    // Detect Tab into menu to switch browsing state
    $triggerLink.on('focusout', function(e) {
      if (state === 'justOpened') {
        state = 'browsing';
      }
    });

    // Close on click outside or focus outside of menu when browsing
    $(document).on('click.megaMenu-' + sectionId + ' keydown.megaMenu-' + sectionId + ' focusin.megaMenu-' + sectionId, function(e) {
      if (e.type === 'click') {
        // Click outside closes the menu
        if (state !== 'closed' && !$(e.target).closest($menuEl).length && !$(e.target).closest($triggerLink).length) {
          closeMenu();
        }
      } else if (e.type === 'keydown' && e.key === 'Escape') {
        // Pressing Escape anywhere while menu is open closes it
        if (state !== 'closed') {
          e.preventDefault();
          closeMenu();
          $triggerLink.focus();
        }
      } else if (e.type === 'focusin') {
        // Focus moved – if new target is outside menu and trigger, close it
        if (state !== 'closed' && !$(e.target).closest($menuEl).length && !$(e.target).closest($triggerLink).length) {
          closeMenu();
        }
      }
    });
  },

  setupMobileIntegration: function(parentLink, sectionId, $megaMenu) {
    // Wait for mobile menu to be ready
    setTimeout(() => {
      const $mobileMenuLinks = $('.mobile-menu__link').filter(function() {
        const linkText = $(this).text().trim().toLowerCase();
        const handleizedLinkText = linkText.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        // Compare both original text and handleized version of parent_link
        return linkText === parentLink.toLowerCase() || handleizedLinkText === parentLink.toLowerCase();
      });

      $mobileMenuLinks.each(function() {
        const $link = $(this);
        const $listItem = $link.closest('.mobile-menu__list-item');
        
        // Check if this link already has a submenu button
        const $existingButton = $listItem.find('.mobile-menu__submenu-toggle');
        const $existingSubmenu = $listItem.find('.mobile-menu__submenu');
        
        if ($existingSubmenu.length) {
          // Replace existing submenu content with mega menu
          $existingSubmenu.empty().append($megaMenu.clone());
          $existingSubmenu.addClass('has-mega-menu');
        } else {
          // Create new submenu structure for mega menu
          const submenuId = 'mega-mobile-submenu-' + sectionId;
          
          // Wrap link in item wrapper if not already wrapped
          if (!$link.parent().hasClass('mobile-menu__item-wrapper')) {
            $link.wrap('<div class="mobile-menu__item-wrapper"></div>');
          }
          
          // Add toggle button
          const toggleButton = document.createElement('button');
          toggleButton.type = 'button';
          toggleButton.className = 'mobile-menu__submenu-toggle';
          toggleButton.setAttribute('aria-expanded', 'false');
          toggleButton.setAttribute('aria-controls', submenuId);
          toggleButton.innerHTML = `
            <span class="visually-hidden">Open ${$link.text().trim()} menu</span>
            <svg class="icon" viewBox="0 0 20 20"><path d="M5 7l5 5 5-5z"/></svg>
          `;
          $link.parent()[0].appendChild(toggleButton);
          
          // Add submenu container
          const submenu = document.createElement('ul');
          submenu.id = submenuId;
          submenu.className = 'mobile-menu__submenu has-mega-menu';
          submenu.hidden = true;

          // Clone mega menu without script tags to avoid duplicate initializations
          const $megaClone = $megaMenu.clone();
          $megaClone.find('script').remove();
          submenu.appendChild($megaClone[0]);
          $listItem[0].appendChild(submenu);
          
          // Event delegation will handle the click events via mobileMenu.js
        }
      });
    }, 100); // Small delay to ensure mobile menu is rendered
  }
}

/******/ })()
;